import { Helmet } from "react-helmet-async";

const SITE = "PROBWA";
const DOMAIN = "https://probwa.re";
const DEFAULT_IMAGE = `${DOMAIN}/images/og-probwa.jpg`;
const PHONE = "+262692502685";

export function SEO({ title, description, path = "/", type = "website", image }) {
  const fullTitle = path === "/" ? `${SITE} — Terrasses & Aménagements en Bambou à La Réunion` : `${title} | ${SITE}`;
  const url = `${DOMAIN}${path}`;
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph (Facebook, Instagram) */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />

      {/* Geo */}
      <meta name="geo.region" content="RE" />
      <meta name="geo.placename" content="La Réunion" />
    </Helmet>
  );
}

export function LocalBusinessSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "PROBWA — Eco Bois Concept",
    description: "Spécialiste des terrasses, bardages et parquets en bambou à La Réunion. Revendeur officiel REBO Bamboo.",
    url: DOMAIN,
    telephone: PHONE,
    email: "contact@probwa.re",
    address: {
      "@type": "PostalAddress",
      addressRegion: "La Réunion",
      addressCountry: "FR",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: "-21.1151",
      longitude: "55.5364",
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "08:00",
      closes: "17:00",
    },
    priceRange: "€€",
    image: DEFAULT_IMAGE,
    sameAs: [],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}

export function ProductSchema({ name, description, image, price }) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Product",
    name,
    description,
    image: image || DEFAULT_IMAGE,
    brand: { "@type": "Brand", name: "REBO Bamboo" },
    manufacturer: { "@type": "Organization", name: "REBO Bamboo" },
    offers: {
      "@type": "Offer",
      priceCurrency: "EUR",
      availability: "https://schema.org/InStock",
      seller: { "@type": "Organization", name: "PROBWA" },
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}

export function FAQSchema({ items }) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
